import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { GiftcardCategoryV2Service } from 'src/app/shared-data';
import { EStaticCategory } from 'src/app/shared-data/giftcard-category.service';
import { ETagProduct, ETagType, GiftCard } from '~models';
import { GiftCardsV2Service, TrxService } from '~services';

@Component({
  selector: 'app-gift-card-category-v2',
  templateUrl: './gift-card-category.component.html',
  styleUrls: ['./gift-card-category.component.scss'],
  standalone: false,
})
export class GiftCardCategoryV2Component implements OnInit {
  @ViewChild('listCategoriesBox', { static: true }) listCategoriesBoxRef: ElementRef;

  shouldShowZipMoneyOnlyDealsCategory = false;
  shouldShowOtherDealsCategory = false;
  staticCategory = EStaticCategory;

  private allGiftCards: GiftCard[] = [];

  constructor(
    public giftcardCategoryV2Service: GiftcardCategoryV2Service,
    public giftCardV2Service: GiftCardsV2Service,
    private trxService: TrxService,
  ) {}

  async ngOnInit() {
    this.giftcardCategoryV2Service.setCategoryBoxRef(this.listCategoriesBoxRef);
    const giftCards = await this.giftCardV2Service.getCards();
    this.allGiftCards = [...giftCards];
    this.shouldShowZipMoneyOnlyDealsCategory = this.getShouldShowZipMoneyOnlyDealsCategory();
    this.shouldShowOtherDealsCategory = this.getShouldShowOtherDealsCategory();
  }

  public toggleActive(categoryId: EStaticCategory) {
    this.giftcardCategoryV2Service.setSelectedCategoryId(categoryId);
    this.giftCardV2Service.getCardCategoryById(categoryId);
    this.giftcardCategoryV2Service.setSearchGiftCardsInput('');
    this.trxService.sendUIClickEvent({
      action_type: 'click',
      control_type: 'button',
      label: `Category: ${categoryId}`,
      control_id: null,
      destination_target_url: null,
    });
  }

  private getShouldShowZipMoneyOnlyDealsCategory() {
    return this.allGiftCards.some((g) =>
      g.tags?.some(
        (t) =>
          t.type === ETagType.CASHBACK &&
          t.products?.length === 1 &&
          t.products[0] === ETagProduct.ZM,
      ),
    );
  }

  private getShouldShowOtherDealsCategory() {
    return this.allGiftCards.some((g) =>
      g.tags?.some(
        (t) =>
          t.products?.length > 1 || (t.products?.length === 1 && t.products[0] !== ETagProduct.ZM),
      ),
    );
  }
}
